/**
 * @deprecated - Will be removed with the Angular 23 migration.
 * Use the [CSS Grid](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/components-style-grid--docs)
 * in ap/style instead
 */
export const allowedTagNames: string[] = ['AP-GRID-COL', 'TD', 'TH'];
